export function canUseOnboardingDraftMode() {
  try {
    const host = String(window.location.hostname || "").trim().toLowerCase();
    const isLocal =
      host === "localhost" ||
      host === "127.0.0.1" ||
      host === "0.0.0.0" ||
      host.endsWith(".local");

    return !!import.meta.env.DEV && isLocal;
  } catch {
    return false;
  }
}
